import { useState } from "react"
import s from "./Settings.module.css"
import { PriceType, SHOP_IDENT } from "../../app/reducers/settingsReducer"
import { calcYaLogisticByWeight } from "./helpers/calcYaLogisticByWeight"
import { selectShopsStore } from "../../app/reducers/shopsSlice"
import { useAppSelector } from "../../app/hooks"
import { getCalcByIdent } from "./helpers/getCalcByIdent"
import { selectFeedShopsStore } from "../../app/reducers/feedShopsSlice"
import { TextField, Button } from "@radix-ui/themes"

export const Calculator = (
  props: PriceType & {
    price?: number
    shop: SHOP_IDENT
  },
) => {
  const { sale = 0, shop, ...priceParams } = props
  const shops = useAppSelector(selectShopsStore)
  const feedShops = useAppSelector(selectFeedShopsStore)

  const [price, setPrice] = useState<number>()
  const [result, setResult] = useState<{ price: number; old_price: number }>()
  const [sizes, setSizes] = useState<{
    width: number
    height: number
    length: number
  }>({
    width: 10,
    height: 30,
    length: 50,
  })
  const [weight, setWeight] = useState<number>(1)
  const calcIdent = shops?.[shop]?.calcIdent || feedShops?.[shop]?.calcIdent
  const calc = getCalcByIdent(calcIdent || "default1")
  const volumeWeight = (sizes.width * sizes.height * sizes.length) / 5000
  const totalWeight = Math.max(weight, volumeWeight)

  return (
    <div>
      <h5>Калькулятор</h5>
      <div>
        <div>
          <div className={s.inputWrap}>
            <label htmlFor="price">Входная цена</label>
            <TextField.Root
              size="3"
              value={price}
              onChange={(e) => setPrice(Number(e.target.value))}
              name="price"
              type="number"
              min="0"
            />
          </div>
          {[SHOP_IDENT.SAMSON_YANDEX, SHOP_IDENT.KATREN_YANDEX].includes(
            shop,
          ) && (
            <div className={s.inputWrap}>
              <label htmlFor="weight">Вес</label>
              <TextField.Root
                size="3"
                value={weight}
                onChange={(e) => setWeight(Number(e.target.value))}
                name="weight"
                type="number"
                min="0"
              />
            </div>
          )}
          {([
            SHOP_IDENT.SAMSON,
            SHOP_IDENT.SAMSON_YANDEX,
            SHOP_IDENT.KATREN_YANDEX,
          ].includes(shop) ||
            ["with_sizes_1"].includes(calcIdent || "")) && (
            <div className={s.sizesWrap}>
              <div className={s.inputWrap}>
                <label htmlFor="width">Ширина, см</label>
                <TextField.Root
                  size="3"
                  value={sizes.width}
                  onChange={(e) =>
                    setSizes({ ...sizes, width: Number(e.target.value) })
                  }
                  name="width"
                  type="number"
                  min="0"
                />
              </div>
              <div className={s.inputWrap}>
                <label htmlFor="height">Высота, см</label>
                <TextField.Root
                  size="3"
                  value={sizes.height}
                  onChange={(e) =>
                    setSizes({ ...sizes, height: Number(e.target.value) })
                  }
                  name="height"
                  type="number"
                  min="0"
                />
              </div>
              <div className={s.inputWrap}>
                <label htmlFor="length">Длина, см</label>
                <TextField.Root
                  size="3"
                  value={sizes.length}
                  onChange={(e) =>
                    setSizes({ ...sizes, length: Number(e.target.value) })
                  }
                  name="length"
                  type="number"
                  min="0"
                />
              </div>
              {[SHOP_IDENT.SAMSON_YANDEX, SHOP_IDENT.KATREN_YANDEX].includes(
                shop,
              ) && (
                <div className={s.inputWrap}>
                  <label htmlFor="length">Объемный вес, кг.</label>
                  <TextField.Root
                    size="3"
                    value={volumeWeight}
                    disabled
                    name="length"
                    type="number"
                    min="0"
                  />
                </div>
              )}
            </div>
          )}
          <div className={s.inputWrap}>
            <label htmlFor="profit">Скидка</label>
            <TextField.Root
              size="3"
              value={sale * 100}
              disabled
              name="sale"
              type="number"
              min="0"
              max="100"
            />
          </div>
          {([SHOP_IDENT.SAMSON].includes(shop) ||
            ["with_sizes_1"].includes(calcIdent || "")) && (
            <div className={s.inputWrap}>
              <label htmlFor="liters">Количество литров</label>
              <TextField.Root
                size="3"
                value={(sizes.width * sizes.height * sizes.length) / 1000}
                disabled
                name="liters"
                type="number"
              />
            </div>
          )}
          {[SHOP_IDENT.SAMSON_YANDEX, SHOP_IDENT.KATREN_YANDEX].includes(
            shop,
          ) && (
            <div className={s.sizesWrap}>
              <div className={s.inputWrap}>
                <label htmlFor="weight">Итоговый вес</label>
                <TextField.Root
                  size="3"
                  value={totalWeight + "кг."}
                  disabled
                  name="weight"
                  type="text"
                />
              </div>
              <div className={s.inputWrap}>
                <label htmlFor="weight">Итоговая цена за вес</label>
                <TextField.Root
                  size="3"
                  value={calcYaLogisticByWeight(totalWeight)}
                  disabled
                  name="weight"
                  type="text"
                />
              </div>
            </div>
          )}
          <div className={s.calcPriceWrap}>
            <Button
              onClick={() =>
                setResult(
                  calc({
                    ...priceParams,
                    price,
                    sale: sale * 100,
                    liters: (sizes.width * sizes.height * sizes.length) / 1000,
                    weight: totalWeight,
                  }),
                )
              }
            >
              Рассчитать
            </Button>
            <div style={{ display: "flex" }}>
              <b style={{ fontSize: "25px" }}>{result?.price}</b>{" "}
              {(sale && <s>{result?.old_price}</s>) || ""}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
